import { render, staticRenderFns } from "./homeLecturerItem.vue?vue&type=template&id=3e92e560&scoped=true&"
import script from "./homeLecturerItem.vue?vue&type=script&lang=js&"
export * from "./homeLecturerItem.vue?vue&type=script&lang=js&"
import style0 from "./homeLecturerItem.vue?vue&type=style&index=0&id=3e92e560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e92e560",
  null
  
)

export default component.exports